import { z } from 'zod';

export const coachGradeSchema = z.enum(['S', 'A', 'B', 'C', 'D', 'New']);
export type CoachGrade = z.infer<typeof coachGradeSchema>;
export const CoachGrade = coachGradeSchema.enum;

export const coachGradeOptions = coachGradeSchema.options;
